// Mock Data - Simula los datos que vendrán del backend .NET Core

export const categories = [
  { id: 1, name: 'Portada', slug: 'portada', color: '#1a1a2e', icon: 'newspaper' },
  { id: 2, name: 'Política', slug: 'politica', color: '#16213e', icon: 'landmark' },
  { id: 3, name: 'Economía', slug: 'economia', color: '#0f3460', icon: 'trending-up' },
  { id: 4, name: 'Deportes', slug: 'deportes', color: '#e94560', icon: 'trophy' },
  { id: 5, name: 'Cultura', slug: 'cultura', color: '#533483', icon: 'palette' },
  { id: 6, name: 'Internacional', slug: 'internacional', color: '#0d7377', icon: 'globe' },
  { id: 7, name: 'Tecnología', slug: 'tecnologia', color: '#14a76c', icon: 'cpu' },
  { id: 8, name: 'Opinión', slug: 'opinion', color: '#ff7b54', icon: 'message-square' },
  { id: 9, name: 'Sociedad', slug: 'sociedad', color: '#706fd3', icon: 'users' },
  { id: 10, name: 'Judicial', slug: 'judicial', color: '#8b0000', icon: 'scale' },
];

export const authors = [
  { id: 1, name: 'María García López', role: 'Editora Jefe', avatar: null, email: 'maria.garcia@periodico.com' },
  { id: 2, name: 'Carlos Rodríguez', role: 'Corresponsal Político', avatar: null, email: 'carlos.rodriguez@periodico.com' },
  { id: 3, name: 'Ana Martínez', role: 'Periodista Deportivo', avatar: null, email: 'ana.martinez@periodico.com' },
  { id: 4, name: 'Luis Hernández', role: 'Analista Económico', avatar: null, email: 'luis.hernandez@periodico.com' },
  { id: 5, name: 'Patricia Sánchez', role: 'Corresponsal Internacional', avatar: null, email: 'patricia.sanchez@periodico.com' },
  { id: 6, name: 'Roberto Díaz', role: 'Columnista', avatar: null, email: 'roberto.diaz@periodico.com' },
];

export const articles = [
  {
    id: 1,
    title: 'El Gobierno presenta nuevo plan de infraestructura para el país',
    subtitle: 'La inversión superará los 50 billones de pesos en los próximos cuatro años',
    slug: 'gobierno-nuevo-plan-infraestructura',
    excerpt: 'El presidente anunció un ambicioso plan de modernización de carreteras, puentes y transporte público que transformará la conectividad del país.',
    content: `
      <p>En un evento histórico celebrado esta mañana en el Palacio de Gobierno, el presidente de la República anunció un ambicioso plan de infraestructura que promete transformar la conectividad del país en los próximos cuatro años.</p>
      
      <p>El plan, denominado "Conectando Colombia 2030", contempla una inversión sin precedentes de más de 50 billones de pesos que se destinarán a la construcción y modernización de carreteras, puentes, sistemas de transporte público y aeropuertos regionales.</p>
      
      <h3>Principales proyectos</h3>
      
      <p>Entre los proyectos más destacados se encuentran:</p>
      
      <p>La construcción de más de 2,000 kilómetros de vías de cuarta generación que conectarán las principales ciudades del país con los puertos marítimos, reduciendo significativamente los tiempos de transporte de mercancías.</p>
      
      <p>La implementación de sistemas de metro ligero en cinco ciudades intermedias, lo que beneficiará a más de 8 millones de habitantes que actualmente dependen del transporte público tradicional.</p>
      
      <p>La modernización de 15 aeropuertos regionales para impulsar el turismo y el comercio en zonas que históricamente han estado aisladas de los principales centros económicos.</p>
      
      <h3>Financiamiento</h3>
      
      <p>Según explicó el Ministro de Hacienda, el financiamiento provendrá de una combinación de recursos propios del Estado, créditos internacionales y asociaciones público-privadas.</p>
      
      <p>"Este es el plan de infraestructura más ambicioso de nuestra historia", afirmó el ministro. "Estamos comprometidos con cerrar la brecha de conectividad que ha limitado el desarrollo de muchas regiones".</p>
    `,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200',
    categoryId: 2,
    authorId: 2,
    featured: true,
    trending: true,
    views: 15420,
    publishedAt: '2024-12-26T08:30:00Z',
    updatedAt: '2024-12-26T10:15:00Z',
    tags: ['infraestructura', 'gobierno', 'inversión', 'transporte'],
  },
  {
    id: 2,
    title: 'La bolsa cierra con ganancias récord impulsada por el sector tecnológico',
    subtitle: 'El índice principal subió un 3.2% en la jornada de ayer',
    slug: 'bolsa-ganancias-record-tecnologia',
    excerpt: 'Los inversores celebran los resultados trimestrales de las principales empresas tecnológicas que superaron las expectativas del mercado.',
    content: `
      <p>El mercado bursátil cerró ayer con ganancias históricas, impulsado principalmente por el excelente desempeño del sector tecnológico, que registró subidas de hasta el 5% en algunas de sus principales acciones.</p>
      
      <p>El índice principal de la bolsa subió un 3.2%, alcanzando su nivel más alto en los últimos cinco años. Los analistas atribuyen este rally a los sorprendentes resultados trimestrales presentados por las grandes empresas tecnológicas.</p>
      
      <h3>Empresas destacadas</h3>
      
      <p>Las empresas de inteligencia artificial lideraron las ganancias, con incrementos que superaron el 8% en algunos casos. Los inversores muestran un renovado optimismo sobre el potencial de estas tecnologías para transformar múltiples industrias.</p>
      
      <p>El sector de semiconductores también tuvo un día excepcional, beneficiándose de la creciente demanda de chips avanzados para centros de datos y aplicaciones de IA.</p>
    `,
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200',
    categoryId: 3,
    authorId: 4,
    featured: true,
    trending: true,
    views: 12350,
    publishedAt: '2024-12-26T09:00:00Z',
    updatedAt: '2024-12-26T09:00:00Z',
    tags: ['bolsa', 'tecnología', 'inversiones', 'economía'],
  },
  {
    id: 3,
    title: 'Selección nacional clasifica al mundial tras histórica victoria',
    subtitle: 'El equipo derrotó 3-1 a su rival en un partido memorable',
    slug: 'seleccion-clasifica-mundial-victoria',
    excerpt: 'Con una actuación brillante, la selección aseguró su boleto al campeonato mundial de fútbol del próximo año.',
    content: `
      <p>La selección nacional escribió una nueva página dorada en su historia al clasificar al mundial de fútbol con una contundente victoria de 3-1 ante su rival directo en la última fecha de las eliminatorias.</p>
      
      <p>El estadio, completamente lleno con más de 70,000 aficionados, fue testigo de una actuación memorable del equipo, que dominó el partido de principio a fin.</p>
      
      <h3>Los goles</h3>
      
      <p>El capitán del equipo abrió el marcador al minuto 23 con un espectacular tiro libre que dejó sin oportunidad al portero rival. El segundo gol llegó al minuto 45, justo antes del descanso, en una jugada colectiva que culminó con un remate de volea.</p>
      
      <p>Aunque el rival descontó al inicio del segundo tiempo, la selección respondió rápidamente con el tercero al minuto 67, sellando así su clasificación al evento deportivo más importante del mundo.</p>
    `,
    image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200',
    categoryId: 4,
    authorId: 3,
    featured: true,
    trending: true,
    views: 45230,
    publishedAt: '2024-12-25T22:00:00Z',
    updatedAt: '2024-12-26T06:30:00Z',
    tags: ['fútbol', 'selección', 'mundial', 'deportes'],
  },
  {
    id: 4,
    title: 'Nuevo museo de arte contemporáneo abre sus puertas al público',
    subtitle: 'La obra arquitectónica ha sido catalogada como una de las más innovadoras del país',
    slug: 'nuevo-museo-arte-contemporaneo',
    excerpt: 'El espacio cultural albergará más de 5,000 obras de artistas nacionales e internacionales.',
    content: `
      <p>Después de cinco años de construcción, el nuevo Museo de Arte Contemporáneo abrió oficialmente sus puertas al público, convirtiéndose en el espacio cultural más grande del país.</p>
      
      <p>El edificio, diseñado por el reconocido arquitecto internacional, combina elementos modernos con referencias a la arquitectura tradicional local, creando un diálogo único entre pasado y presente.</p>
      
      <h3>Colección inaugural</h3>
      
      <p>La colección inaugural incluye más de 500 obras de artistas contemporáneos de todo el mundo, incluyendo piezas de algunos de los creadores más influyentes de las últimas décadas.</p>
      
      <p>El museo también contará con espacios dedicados a instalaciones interactivas, talleres educativos y una biblioteca especializada en arte moderno.</p>
    `,
    image: 'https://images.unsplash.com/photo-1554907984-15263bfd63bd?w=1200',
    categoryId: 5,
    authorId: 1,
    featured: false,
    trending: false,
    views: 8750,
    publishedAt: '2024-12-26T07:00:00Z',
    updatedAt: '2024-12-26T07:00:00Z',
    tags: ['cultura', 'arte', 'museo', 'arquitectura'],
  },
  {
    id: 5,
    title: 'Cumbre climática logra acuerdo histórico para reducir emisiones',
    subtitle: 'Más de 150 países se comprometen a alcanzar la neutralidad de carbono para 2050',
    slug: 'cumbre-climatica-acuerdo-emisiones',
    excerpt: 'El pacto incluye compromisos vinculantes y un fondo de financiamiento para países en desarrollo.',
    content: `
      <p>En lo que ha sido calificado como un hito en la lucha contra el cambio climático, la cumbre internacional concluyó con un acuerdo sin precedentes firmado por más de 150 países.</p>
      
      <p>El pacto establece compromisos vinculantes para reducir las emisiones de gases de efecto invernadero en un 50% para 2035 y alcanzar la neutralidad de carbono para 2050.</p>
      
      <h3>Fondo de financiamiento</h3>
      
      <p>Uno de los aspectos más destacados del acuerdo es la creación de un fondo de 500 mil millones de dólares para apoyar la transición energética en países en desarrollo.</p>
      
      <p>Los líderes mundiales expresaron su optimismo sobre el impacto de estas medidas, aunque los grupos ambientalistas advirtieron que la implementación será el verdadero desafío.</p>
    `,
    image: 'https://images.unsplash.com/photo-1569163139599-0f4517e36f51?w=1200',
    categoryId: 6,
    authorId: 5,
    featured: true,
    trending: true,
    views: 23100,
    publishedAt: '2024-12-26T06:00:00Z',
    updatedAt: '2024-12-26T08:45:00Z',
    tags: ['clima', 'internacional', 'medio ambiente', 'acuerdos'],
  },
  {
    id: 6,
    title: 'Startup local desarrolla inteligencia artificial para diagnóstico médico',
    subtitle: 'El sistema puede detectar enfermedades con una precisión del 95%',
    slug: 'startup-ia-diagnostico-medico',
    excerpt: 'La tecnología ya está siendo probada en varios hospitales de la región con resultados prometedores.',
    content: `
      <p>Una startup fundada por investigadores locales ha desarrollado un sistema de inteligencia artificial capaz de asistir en el diagnóstico de múltiples enfermedades con una precisión que supera el 95%.</p>
      
      <p>El sistema, denominado "MediAI", analiza imágenes médicas, resultados de laboratorio y el historial clínico del paciente para sugerir diagnósticos y tratamientos potenciales.</p>
      
      <h3>Pruebas clínicas</h3>
      
      <p>Actualmente, la tecnología está siendo probada en cinco hospitales de la región, donde ha demostrado ser especialmente efectiva en la detección temprana de cáncer y enfermedades cardiovasculares.</p>
      
      <p>Los desarrolladores esperan obtener la aprobación regulatoria el próximo año para comenzar la comercialización a nivel nacional.</p>
    `,
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200',
    categoryId: 7,
    authorId: 4,
    featured: false,
    trending: true,
    views: 18900,
    publishedAt: '2024-12-26T05:30:00Z',
    updatedAt: '2024-12-26T05:30:00Z',
    tags: ['tecnología', 'salud', 'inteligencia artificial', 'innovación'],
  },
  {
    id: 7,
    title: 'El futuro de la democracia en la era digital',
    subtitle: 'Reflexiones sobre los desafíos que enfrentan nuestras instituciones',
    slug: 'futuro-democracia-era-digital',
    excerpt: 'Columna de opinión sobre cómo las redes sociales y la tecnología están transformando la participación política.',
    content: `
      <p>Vivimos tiempos de profunda transformación. Las instituciones democráticas que construimos durante siglos enfrentan hoy desafíos sin precedentes en la era de la información instantánea.</p>
      
      <p>Las redes sociales han democratizado el acceso a la información, pero también han creado nuevos riesgos: la desinformación, las burbujas de opinión y la polarización extrema amenazan la capacidad de los ciudadanos para tomar decisiones informadas.</p>
      
      <h3>Una nueva ciudadanía</h3>
      
      <p>El desafío no es rechazar la tecnología, sino aprender a integrarla de manera que fortalezca, en lugar de debilitar, nuestro tejido democrático.</p>
      
      <p>Necesitamos una nueva forma de ciudadanía digital, una que combine el pensamiento crítico con la participación activa y el respeto por la diversidad de opiniones.</p>
    `,
    image: 'https://images.unsplash.com/photo-1494172892981-ce47ca3e3e2d?w=1200',
    categoryId: 8,
    authorId: 6,
    featured: false,
    trending: false,
    views: 5600,
    publishedAt: '2024-12-26T04:00:00Z',
    updatedAt: '2024-12-26T04:00:00Z',
    tags: ['opinión', 'democracia', 'tecnología', 'sociedad'],
  },
  {
    id: 8,
    title: 'Programa de vivienda social beneficiará a 100,000 familias',
    subtitle: 'El gobierno anuncia construcción de nuevos proyectos habitacionales',
    slug: 'programa-vivienda-social-familias',
    excerpt: 'Los nuevos desarrollos incluirán viviendas sostenibles con acceso a servicios básicos.',
    content: `
      <p>El Ministerio de Vivienda anunció un ambicioso programa de construcción de viviendas sociales que beneficiará a más de 100,000 familias de bajos recursos en los próximos tres años.</p>
      
      <p>El programa, con una inversión de 15 billones de pesos, contempla la construcción de desarrollos habitacionales en 50 municipios del país, priorizando aquellos con mayor déficit de vivienda.</p>
      
      <h3>Viviendas sostenibles</h3>
      
      <p>Cada vivienda contará con sistemas de ahorro de agua, paneles solares y huertos comunitarios, como parte del compromiso del gobierno con la sostenibilidad ambiental.</p>
      
      <p>Las familias podrán acceder a las viviendas a través de subsidios y créditos con tasas de interés preferenciales.</p>
    `,
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200',
    categoryId: 9,
    authorId: 1,
    featured: false,
    trending: false,
    views: 9800,
    publishedAt: '2024-12-25T18:00:00Z',
    updatedAt: '2024-12-25T18:00:00Z',
    tags: ['vivienda', 'sociedad', 'gobierno', 'sostenibilidad'],
  },
  {
    id: 9,
    title: 'Fiscalía desmantela red de corrupción en contratos públicos',
    subtitle: 'Más de 30 funcionarios han sido vinculados a la investigación',
    slug: 'fiscalia-red-corrupcion-contratos',
    excerpt: 'La operación reveló un esquema de sobornos que habría desviado miles de millones de pesos.',
    content: `
      <p>La Fiscalía General de la Nación anunció el desmantelamiento de una red de corrupción que operaba en la adjudicación de contratos públicos en varias entidades del Estado.</p>
      
      <p>La investigación, que se prolongó por más de dos años, reveló un esquema sistemático de sobornos y comisiones ilegales que habrían desviado más de 5,000 millones de pesos de recursos públicos.</p>
      
      <h3>Capturas y procesos</h3>
      
      <p>Hasta el momento, más de 30 funcionarios públicos y contratistas han sido vinculados a la investigación. Se espera que las primeras audiencias de imputación se realicen en las próximas semanas.</p>
      
      <p>El Fiscal General calificó la operación como "un golpe contundente a la corrupción estructural".</p>
    `,
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    categoryId: 10,
    authorId: 2,
    featured: false,
    trending: true,
    views: 28500,
    publishedAt: '2024-12-25T20:00:00Z',
    updatedAt: '2024-12-26T07:00:00Z',
    tags: ['judicial', 'corrupción', 'fiscalía', 'investigación'],
  },
  {
    id: 10,
    title: 'Descubren nueva especie de orquídea en parque nacional',
    subtitle: 'Científicos locales realizan el hallazgo durante expedición de investigación',
    slug: 'nueva-especie-orquidea-parque',
    excerpt: 'La flor presenta características únicas que la distinguen de las más de 4,000 especies conocidas en el país.',
    content: `
      <p>Un equipo de biólogos del Instituto de Investigaciones Naturales descubrió una nueva especie de orquídea durante una expedición científica en el Parque Nacional Natural.</p>
      
      <p>La especie, que será nombrada en honor al botánico colombiano que lideró la expedición, presenta un patrón de coloración único que no se ha observado en ninguna de las más de 4,000 especies de orquídeas registradas en el país.</p>
      
      <h3>Importancia del descubrimiento</h3>
      
      <p>Este hallazgo refuerza la importancia de proteger los ecosistemas naturales y continuar con los programas de investigación en biodiversidad.</p>
      
      <p>Colombia es el segundo país con mayor diversidad de orquídeas en el mundo, y este descubrimiento añade un nuevo tesoro a su patrimonio natural.</p>
    `,
    image: 'https://images.unsplash.com/photo-1566907225848-3e4f5c5c5c29?w=1200',
    categoryId: 5,
    authorId: 5,
    featured: false,
    trending: false,
    views: 4200,
    publishedAt: '2024-12-24T14:00:00Z',
    updatedAt: '2024-12-24T14:00:00Z',
    tags: ['ciencia', 'naturaleza', 'biodiversidad', 'descubrimiento'],
  },
];

export const editions = [
  {
    id: 1,
    number: 15234,
    title: 'Edición del Jueves 26 de Diciembre de 2024',
    date: '2024-12-26',
    coverImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200',
    mainHeadline: 'El Gobierno presenta nuevo plan de infraestructura para el país',
    status: 'published',
    articles: [1, 2, 3, 5, 6, 9],
    pages: [
      { number: 1, section: 'Portada', articles: [1] },
      { number: 2, section: 'Política', articles: [2] },
      { number: 3, section: 'Economía', articles: [3] },
      { number: 4, section: 'Internacional', articles: [5] },
      { number: 5, section: 'Tecnología', articles: [6] },
      { number: 6, section: 'Judicial', articles: [9] },
    ],
    createdAt: '2024-12-25T20:00:00Z',
    publishedAt: '2024-12-26T05:00:00Z',
  },
  {
    id: 2,
    number: 15233,
    title: 'Edición del Miércoles 25 de Diciembre de 2024',
    date: '2024-12-25',
    coverImage: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200',
    mainHeadline: 'Selección nacional clasifica al mundial tras histórica victoria',
    status: 'published',
    articles: [3, 4, 7, 8, 10],
    pages: [
      { number: 1, section: 'Portada', articles: [3] },
      { number: 2, section: 'Deportes', articles: [3] },
      { number: 3, section: 'Cultura', articles: [4, 10] },
      { number: 4, section: 'Opinión', articles: [7] },
      { number: 5, section: 'Sociedad', articles: [8] },
    ],
    createdAt: '2024-12-24T20:00:00Z',
    publishedAt: '2024-12-25T05:00:00Z',
  },
  {
    id: 3,
    number: 15235,
    title: 'Edición del Viernes 27 de Diciembre de 2024',
    date: '2024-12-27',
    coverImage: null,
    mainHeadline: 'Próxima edición en preparación',
    status: 'draft',
    articles: [],
    pages: [],
    createdAt: '2024-12-26T10:00:00Z',
    publishedAt: null,
  },
];

// Config de branding de fallback usada solo cuando USE_MOCK=true.
// El nombre y el tagline reales viven en la BD y se administran desde el CMS.
// La marca del proyecto anterior no puede usarse en ningún campo (es de un tercero).
export const newspaperConfig = {
  name: '',
  slogan: '',
  foundedYear: null,
  location: 'Bucaramanga, Santander',
  country: 'Colombia',
  logo: null,
  colors: {
    primary: '#1a1a2e',
    secondary: '#16213e',
    accent: '#e94560',
    background: '#fafafa',
    text: '#1a1a2e',
  },
  social: {
    twitter: '@eldiario',
    facebook: 'eldiario',
    instagram: '@eldiario',
    youtube: 'eldiario',
  },
  contact: {
    email: 'contacto@eldiario.com',
    phone: '+57 7 123 4567',
    address: 'Calle 36 #15-23, Bucaramanga',
  },
};

export const advertising = [
  {
    id: 1,
    name: 'Banner Principal',
    position: 'header',
    image: 'https://via.placeholder.com/728x90?text=Publicidad',
    link: '#',
    active: true,
  },
  {
    id: 2,
    name: 'Sidebar',
    position: 'sidebar',
    image: 'https://via.placeholder.com/300x250?text=Publicidad',
    link: '#',
    active: true,
  },
];
